import React, { Component } from "react";
import { version } from 'react';
import "../skins_15.2.0/treso/videojs.css";
import videojs from "video.js";
import "../components_15.2.0/es/nuevo";
import { relatedList } from "../related.js";

export default class VideoJs extends Component {

  componentDidMount() {
	  
	const cdnzone = '//opencdn.b-cdn.net';  
	console.log('React version: '+version);
	  
    const videoJsOptions = {
      controls: true,
	  preload: "auto",
	  playsinline: "true",
	  crossorigin:"anonymous",
	  poster: "//opencdn.b-cdn.net/video/hls/tos/tearsd.jpg",
	  sources: {src:"//opencdn.b-cdn.net/video/tears2/playlist.m3u8",type: "application/x-mpegURL"}
	  
    };

	const nuevoOptions = {
		pipButton:false,
		related: relatedList,
		title: "Tears of Steel - React video.js",
		url: "https://www.nuevodeve.com/react/example1/"
	}

    // instantiate Video.js

	   window.videojs = videojs;

	  const script = document.createElement("script");
	  script.src =  "https://opencdn.b-cdn.net/vdjs/v13.7.0/plugins/videojs-chromecast.min.js";
	  document.body.appendChild(script);
	  script.onload = () => {
		const player = this.player =	videojs(this.videoNode, videoJsOptions, function onPlayerReady() {
		
			player.chromecast({
				overlayButton: true,
				metaTitle: "Tears of Steel",
				metaSubtitle: "Sci-fi short movie by the Blender Foundation",
				metaThumbnail: "//opencdn.b-cdn.net/video/hls/tos/tears_cr.png"
			});
			player.src(videoJsOptions.sources);
			player.nuevo(nuevoOptions);

		const captions = [
		      {
			kind: "captions",
			src: "//opencdn.b-cdn.net/video/hls/tears/captions/steal_en.vtt",
			srlang: "en",
			label: "English",
			default: "1"
		      },
		      {
			kind: "captions",
			src: "//opencdn.b-cdn.net/video/hls/tears/captions/steal_de.vtt",
			srlang: "de",
			label: "German",
		      },
		      {
			kind: "captions",
			src: "//opencdn.b-cdn.net/video/hls/tears/captions/steal_fr.vtt",
			srlang: "fr",
			label: "French",
		      },
		      {
			kind: "captions",
			src: "//opencdn.b-cdn.net/video/hls/tears/captions/steal_es.vtt",
			srlang: "es",
			label: "Spanish",
		      },
		      {
			kind:"chapters",
			src: "//opencdn.b-cdn.net/captions/steal_chapters.vtt",
			srclang: "en", 
			label: "Chapters"
		      }
		   ];


		player.on('loadeddata', function(){
			player.loadTracks(captions);
		});


		});
	  }

	

	 
	  document.addEventListener('click',function(e) {
		if(e.target.className==='ex') {
			let warn = document.querySelector('.exwarn');
			if(warn.className=='exwarn')  {
				document.querySelector('.exwarn').classList.add('exwarn-show');
			}
		} else {
			document.querySelector('.exwarn').classList.remove('exwarn-show');
		}
	  });


  }

  // destroy player on unmount
  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }

   render() {
    return (
    <div>
	<header><a href="https://www.nuevodevel.com/nuevo/reactvue">Back to examples</a><a href="https://www.nuevodevel.com/nuevo/">Nuevo</a></header>  
	<div className="container">
		<h1>Video.js React Demo #1</h1>
		<h2>Featuring Nuevo plugin, captions, chapters and Chromecat plugin.</h2>
	    <div className="btn-nav">
		<span className="exbtn exbtn-active">Example 1</span>
		<a className="exbtn" href="/react/example2/">Example2</a>
		<a className="exbtn" href="/react/example3/">Example3</a>
		</div>
	
		<div className="v-parent2"><div className="v-child">
          <video ref={(node) => (this.videoNode = node)} className="video-js vjs-fill" />
		</div></div>

		<div className="desc">
		<p>Demo rendered in React.js version <b>19.2.7</b> </p>
		<p>Presenting Video.js player v <b>8.23.9</b> with the Nuevo plugin v <b>15.2.0</b> and Treso skin.</p>
		<p>Video in HLS format with 4 resolutions to switch between, subtitles in 4 languages and chapters.</p>
		<p>The player includes a Chromecast plugin and a collection of 12 related videos.</p>

		<p className="break"></p>
		<p>We have prepared as many as <b>29 React</b> and <b> 10 Next.js</b> examples covering plugins usage included in Nuevo Software.</p>
		<p> All examples are available to test and to review source code through <b>CodeSandbox</b> editor.</p>

		<div className="cols">
			<ul>
			<li className="ex">Basic Setup</li>
			<li className="ex">Nuevo playlist</li>
			<li className="ex">Nuevo playlist below the player</li>
			<li className="ex">Related videos & sharing options</li>
			<li className="ex">Subtitles - method #1</li>
			<li className="ex">Subtitles - method #2</li>
			<li className="ex">Chapters</li>
			<li className="ex">Audio playback</li>
			<li className="ex">Audio ID Tags plugin</li>
			<li className="ex">Custom language</li>
			<li className="ex">Changing video source</li>
			<li className="ex">VTT Thumnails over progress bar</li>
			<li className="ex">Filters plugin</li>
			<li className="ex">Skip Intro plugin</li>
			<li className="ex">News Ticker plugin</li>
			
		</ul>
		<ul>
			
			<li className="ex">Overlay plugin</li>
			<li className="ex">UpNext plugin</li>
			<li className="ex">More videos gallery</li>
			<li className="ex">Hls.js streaming handler</li>
			<li className="ex">Dash.js streaming handler</li>
			<li className="ex">Offline plugin</li>
			<li className="ex">Video events plugin</li>
			<li className="ex">Transcript plugin</li>
			<li className="ex">Vroll video ads</li>
			<li className="ex">VAST ads</li>
			<li className="ex">VASTPro plugin</li>
			<li className="ex">Chromecast plugin</li>
			<li className="ex">VR/360&deg; plugin</li>
			<li className="ex">React route example</li>
			
		 </ul>
		 </div>
		 <p className="break"></p>
         <h2>Next.js/React available examples</h2>
			 Rendered in Next.js version 15.0.3 and React 19.2.7.
		 <br/>
		 <div className="cols">	 
		 <ul>
			<li className="ex">Basic Setup with VTT Tthumbnails</li>
			<li className="ex">VTT progressbar thumbnails Demo</li>
			<li className="ex">News Ticker plugin</li>
			<li className="ex">Overlay plugin</li>
			<li className="ex">Vroll ads demo</li>
			<li className="ex">Nuevo playlist</li>
			<li className="ex">VAST Video ads demo</li>
			<li className="ex">VASTPro demo</li>
			<li className="ex">Google Ima Ads</li>
			<li className="ex">Chromecast plugin demo</li>
		 </ul>
		</div>
		
		<p className="break"></p>
		<p className="c900">Access to CodeSandbox examples is available for logged-in Nuevo Software Gold Plan users<br/>
		who decide to buy such service in the client area.</p>

		<p className="csb">
			<b>CodeSandbox</b> is a platform for application developers.<br/>
			It features an online code editor and a prototyping tool that runs in a web browser.<br/>
			With CodeSandbox, you can easily learn, experiment, debug and test apps.<br/>
			It's much easier to learn from Codesandbox examples than from any written tutorial. 
			
		</p>


		</div>

     </div>

	 <div className="exwarn">
		 <div className="exclose">&times;</div>
		 Access to example source code is available<br/>
		 for logged Nuevo Software Gold Plan users<br/>
		who purchased such a service.
	 </div>		

	 </div>
	

    );
  }
}